import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

/**
 * 在主框架内显示
 */
const frameIn = [{
	path: '/',
	redirect: {
		name: 'index'
	},
	component: layoutHeaderAside,
	children: [
		// 首页
		{
			path: 'index',
			name: 'index',
			meta: {
				auth: true
			},
			component: _import('system/index')
		},
		// 我的页面
		{
			path: 'UserInfo',
			name: 'UserInfo',
			meta: {
				title: '用户及权限',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/UserInfo/UserInfo')
		},{
			path: 'UpdateLog',
			name: 'UpdateLog',
			meta: {
				title: '更新日志',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/UpdateLog/UpdateLog')
		},{
			path: 'MenuInfo',
			name: 'MenuInfo',
			meta: {
				title: '系统菜单设置',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/MenuInfo/MenuInfo')
		}
		
		
		,{
			path: 'NoticeInfo',
			name: 'NoticeInfo',
			meta: {
				title: '公告管理',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/NoticeInfo/NoticeInfo')
		},{
			path: 'PropertyInfo',
			name: 'PropertyInfo',
			meta: {
				title: '固定资产台账',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/PropertyInfo/PropertyInfo')
		},{
			path: 'LeaveInfo',
			name: 'LeaveInfo',
			meta: {
				title: '请假申请单',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/LeaveInfo/LeaveInfo')
		},{
			path: 'GooutInfo',
			name: 'GooutInfo',
			meta: {
				title: '外出登记',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/GooutInfo/GooutInfo')
		},{
			path: 'MealInfo',
			name: 'MealInfo',
			meta: {
				title: '加班用餐登记',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/MealInfo/MealInfo')
		},{
			path: 'EngageInfo',
			name: 'EngageInfo',
			meta: {
				title: '员工入职登记',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/EngageInfo/EngageInfo')
		},{
			path: 'ResignInfo',
			name: 'ResignInfo',
			meta: {
				title: '员工离职申请',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/ResignInfo/ResignInfo')
		},{
			path: 'InvoiceInfo',
			name: 'InvoiceInfo',
			meta: {
				title: '开具发票申请',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/InvoiceInfo/InvoiceInfo')
		},{
			path: 'ExpenseInfo',
			name: 'ExpenseInfo',
			meta: {
				title: '报销申请',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/ExpenseInfo/ExpenseInfo')
		},{
			path: 'ComBorrowInfo',
			name: 'ComBorrowInfo',
			meta: {
				title: '笔记本借用申请',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/ComBorrowInfo/ComBorrowInfo')
		},{
			path: 'StampInfo',
			name: 'StampInfo',
			meta: {
				title: '用印盖章申请',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/StampInfo/StampInfo')
		},{
			path: 'SoftBorrowInfo',
			name: 'SoftBorrowInfo',
			meta: {
				title: '软件锁借用申请',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/SoftBorrowInfo/SoftBorrowInfo')
		},{
			path: 'DocBorrowInfo',
			name: 'DocBorrowInfo',
			meta: {
				title: '证件借用申请',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/DocBorrowInfo/DocBorrowInfo')
		},{
			path: 'EmployeeInfo',
			name: 'EmployeeInfo',
			meta: {
				title: '员工档案',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/EmployeeInfo/EmployeeInfo')
		},{
			path: 'PropertyBuyInfo',
			name: 'PropertyBuyInfo',
			meta: {
				title: '固定资产申购',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/PropertyBuyInfo/PropertyBuyInfo')
		},{
			path: 'PropertyScrapInfo',
			name: 'PropertyScrapInfo',
			meta: {
				title: '固定资产报废',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/PropertyScrapInfo/PropertyScrapInfo')
		},{
			path: 'PropertyMoveInfo',
			name: 'PropertyMoveInfo',
			meta: {
				title: '固定资产转移',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/PropertyMoveInfo/PropertyMoveInfo')
		},{
			path: 'StationeryInfo',
			name: 'StationeryInfo',
			meta: {
				title: '办公用品库存',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/StationeryInfo/StationeryInfo')
		},{
			path: 'StationeryBuyInfo',
			name: 'StationeryBuyInfo',
			meta: {
				title: '办公用品申购',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/StationeryBuyInfo/StationeryBuyInfo')
		},{
			path: 'StationeryGetInfo',
			name: 'StationeryGetInfo',
			meta: {
				title: '办公用品领用',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/StationeryGetInfo/StationeryGetInfo')
		},{
			path: 'StationeryGetReport1',
			name: 'StationeryGetReport1',
			meta: {
				title: '领用统计表',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/StationeryGetReport1/StationeryGetReport1')
		},
					
		

		// 系统 前端日志
		{
			path: 'log',
			name: 'log',
			meta: {
				title: '前端日志',
				auth: true
			},
			component: _import('system/log')
		},
		// 刷新页面 必须保留
		{
			path: 'refresh',
			name: 'refresh',
			hidden: true,
			component: _import('system/function/refresh')
		},
		// 页面重定向 必须保留
		{
			path: 'redirect/:route*',
			name: 'redirect',
			hidden: true,
			component: _import('system/function/redirect')
		}
	]
}]

/**
 * 在主框架之外显示
 */
const frameOut = [
	// 登录
	{
		path: '/login',
		name: 'login',
		component: _import('system/login')
	}
]

/**
 * 错误页面
 */
const errorPage = [{
	path: '*',
	name: '404',
	component: _import('system/error/404')
}]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [
	...frameIn,
	...frameOut,
	...errorPage
]
